<table mat-table
                       class="table table-hover"
                       matSort="contactSort" [dataSource]="dataSource"
                       infiniteScroll
                       [infiniteScrollDistance]="2"
                       [infiniteScrollThrottle]="20"
                       [infiniteScrollContainer]="tableContact"
                       [fromRoot]="true"
                        [trackBy]="trackByContact"
                       (scrolled)="onTableScroll()">
  <ng-container matColumnDef="Org">
    <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-15-rem">{{OrgTitle}}</th>
    <td mat-cell *matCellDef="let element">{{ element.repoBusiness?.businessName }}</td>
  </ng-container>
  <ng-container matColumnDef="salutation">
    <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-15-rem">Title</th>
    <td mat-cell *matCellDef="let element">{{ element.salutation }}</td>
  </ng-container>

  <ng-container matColumnDef="firstName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-15-rem">First Name</th>
    <td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
  </ng-container>

  <ng-container matColumnDef="lastName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-15-rem">Last Name</th>
    <td mat-cell *matCellDef="let element">{{ element.lastName }}</td>
  </ng-container>

  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-15-rem">Email</th>
    <td mat-cell *matCellDef="let element">{{ element.email }}</td>
  </ng-container>
  <ng-container matColumnDef="countryCode">
    <th style="display: none"
        mat-header-cell
        mat-sort-header
        *matHeaderCellDef
        class="w-15-rem">
      Country Code
    </th>
    <td style="display: none" mat-cell *matCellDef="let element">
      {{ element.countryCode }}
    </td>
  </ng-container>

  <ng-container matColumnDef="mobile">
    <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-15-rem">Mobile</th>
    <td mat-cell *matCellDef="let element">
      {{ element.countryCode }}{{ element.mobile }}
    </td>
  </ng-container>

  <ng-container matColumnDef="position">
    <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-15-rem">Position</th>
    <td mat-cell *matCellDef="let element">
      {{ element.position?.positionName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell
        *matHeaderCellDef
        class="w-15-rem"
        style="text-align: right">
      Action
    </th>
    <td mat-cell *matCellDef="let element" style="text-align: right">
      <button type="button"
              class="btn btn-outline-primary btn-sm"
              (click)="EditContact(element)">
        <i class="fa fa-edit"></i>
      </button>
     <button type="button" class="btn btn-outline-primary btn-sm ms-1"
         (click)="DeleteRepoContact(element)"
         title="Delete Contact">
        <i class="fa fa-trash"></i>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns$.value;sticky: true"></tr>
  <tr mat-row
      *matRowDef="
  let row;
  columns: displayedColumns$.value;
  let saleIndex = index
"
      class="border-start-0 border-end-0 pointer pt-2 tr-fs-13px"></tr>
</table>
